import type { IService } from '../newProcessInterfaces';
import { ServiceCode } from '../../../../../../common/enums/serviceCode';
import { GgzoEmblActionBar } from '../../../customControls/GGZOembl/v1/GgzoEmblActionBar';

export function newProcessLoadCustomControl(service: IService, actionWithProcedure: boolean | undefined) {
    switch (service.code) {
        case ServiceCode.GGZOembl:
            if (!actionWithProcedure) {
                return GgzoEmblActionBar;
            }
            break;
        default:
            return null;
    }

    return null;
}

export function newProcessCanRenderCustomControl(
    service: IService | undefined,
    actionWithProcedure: boolean | undefined
) {
    if (!service) {
        return false;
    }

    return !!newProcessLoadCustomControl(service, actionWithProcedure);
}
